export default __webpack_public_path__ + "static/media/S90.cae1e49b.png";